import { GET_MAP_DATA, SET_MAP_DATA } from '../constants/map';

export const getMapDataAction = (payload) => ({
  type: GET_MAP_DATA,
  payload,
});

export const setMapDataAction = (payload) => ({
  type: SET_MAP_DATA,
  payload,
});
